import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"
import _imports_0 from '../images/biogaia-vision.png'


const _hoisted_1 = { class: "col-md-10 ml-sm-auto pt-3 px-4 text-start home" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8 vh-100" }
const _hoisted_4 = {
  key: 0,
  class: "bold"
}
const _hoisted_5 = { class: "col-md-4 vh-100" }
const _hoisted_6 = { class: "row text-center" }
const _hoisted_7 = {
  key: 0,
  class: "bold"
}
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ContactCard = _resolveComponent("ContactCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Loading, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.userStore.userInfo?.firstName)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_4, " Hello " + _toDisplayString(_ctx.userStore.userInfo?.firstName) + "! ", 1))
          : _createCommentVNode("", true),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card p-3 content-main" }, [
          _createTextVNode(" Welcome to the BioGaia order portal. "),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createTextVNode("If you have any questions regarding the portal, your Supply Account Manager is available to assist you with any portal-related questions while your Sales Manager can help with pricing inquiries. The contact information can be found on the right-hand side of this page."),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createTextVNode("The artwork version numbers shown for the article are the current approved artwork version. Please note that you are only able to order the article with the artwork version numbers shown. If you wish to initiate a new artwork version, please reach out to the BioGaia Design Studio at artwork@biogaia.se."),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createTextVNode(" Once you’ve placed your order our official order confirmation with delivery date should be sent to you within the next 5 working days. "),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createTextVNode(" If you need further support, please don’t hesitate to reach out. Have a wonderful day! "),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Biogaia vision and mission"
          }),
          _createElementVNode("hr")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.userStore.userInfo?.companies)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_7, " Your Accounts "))
            : _createCommentVNode("", true),
          (_ctx.userStore.userInfo?.companies)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 1,
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCompanyChange && _ctx.onCompanyChange(...args))),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCompany) = $event)),
                class: "form-control mb-3"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userStore.sortedCompanies, (value) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: value.customerAccountNumber,
                    value: value
                  }, _toDisplayString(value.companyName), 9, _hoisted_8))
                }), 128))
              ], 544)), [
                [_vModelSelect, _ctx.selectedCompany]
              ])
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "bold" }, "Your Biogaia contacts", -1)),
          (_ctx.userStore.userInfo?.kamInfo)
            ? (_openBlock(), _createBlock(_component_ContactCard, {
                key: 2,
                Contact: _ctx.userStore.userInfo?.kamInfo
              }, null, 8, ["Contact"]))
            : _createCommentVNode("", true),
          (_ctx.userStore.userInfo?.samInfo)
            ? (_openBlock(), _createBlock(_component_ContactCard, {
                key: 3,
                Contact: _ctx.userStore.userInfo?.samInfo
              }, null, 8, ["Contact"]))
            : _createCommentVNode("", true),
          (_ctx.userStore.userInfo?.artwork)
            ? (_openBlock(), _createBlock(_component_ContactCard, {
                key: 4,
                Contact: _ctx.userStore.userInfo?.artwork
              }, null, 8, ["Contact"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}